<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      Reset Password
    </div>

    <div class="content">

      <van-form ref="passwordForm" @submit="onApplyPassword">
        <PasswordField v-model="oldPassword" placeholder="Enter old password" style="margin-top:168px"/>
        <PasswordField ref="newPassword" v-model="newPassword" placeholder="Enter new Password" class="mt-4"/>
        <PasswordField ref="confirmNewPassword" confirm-password-enable :confirm-password="newPassword"
            v-model="confirmPassword" placeholder="Reconfirm new password" class="mt-4"/>
        <div class="w-full mt-12 horizontal items-center">
          <button type="submit" class="apply-btn" style="width:80%" >Apply</button>
        </div>
      </van-form>
    </div>
  </div>
</template>


<script>
import PasswordField from "@/components/PasswordField.vue";
import user from "@/api/user";

export default {
  name: "ResetPassword",
  components: { PasswordField },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.back();
    },

    async onApplyPassword() {
      const resp = await user.resetPassword({
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      });
      if (resp.code !== 200) {
        this.$toast({
          message: resp.message
        })
        return
      }
      await this.$toast({
        message: resp.message
      })
      await this.$router.back()
    }
  }
};
</script>
<style scoped lang="less">
.container {

  background: white;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;
    background: white;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    background: white;

    & > * + * {
      margin-top: 12px;
    }
  }
}


.apply-btn {
  height: 48px;
  line-height: 48px;
  border-radius: 12px;
  border: 1px solid #BEBEBE;
  margin: 48px 56px 0 48px;
  color: #333333;
  font-size: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>